export interface TermsAndCondition {
    status: ResponseStatus,
    action?: ActionStatus,
    termConditionId?: number
}

export enum ResponseStatus{
    COMPLETED = 'completed', // หลัง save เรียบร้อยแล้ว
    SUCCESS = 'success', // หลัง terms cond accept
    FAIL = 'fail', // terms cond ไม่สำเร็จ
    SKIP = 'skip', // ข้าม terms cond
}

export enum ActionStatus{
    ACCEPT = 'accept',
    CANCEL = 'cancel'
}